import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorContracttransaction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M16.5 12.355a.375.375 0 0 1-.26.645H9.75a.75.75 0 0 1 0-1.5h4.302v-1.03a.2.2 0 0 1 .339-.144l2.11 2.029Zm-9 2.29A.375.375 0 0 1 7.76 14h6.49a.75.75 0 0 1 0 1.5H9.948v1.03a.2.2 0 0 1-.339.144L7.5 14.645Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.75 3a.75.75 0 0 1 1.5 0h7.5a.75.75 0 0 1 1.5 0H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h.75Zm9 1.5h-7.5a.75.75 0 0 1-1.5 0H6A1.5 1.5 0 0 0 4.5 6v.75h15V6A1.5 1.5 0 0 0 18 4.5h-.75a.75.75 0 0 1-1.5 0ZM4.5 8.25V18A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5V8.25h-15Z"
    />
  </svg>
);
export default SvgTwoColorContracttransaction;
